import { AttributeType, ExposureDirectionType } from 'data/types';

export function structureOrientationSetting(
  projectSettings: AttributeType[]
): ExposureDirectionType | undefined {
  const setting = projectSettings.find(
    (entry) => entry.code === 'structure_orientation'
  );
  return setting?.value as ExposureDirectionType | undefined;
}
